import { Alert } from 'antd';
import React, { FC } from 'react';
import { printf } from 'utils/i18n';
import styles from './style.scss';

const Instructions: FC = () => {
    return (
        <Alert
            className={styles.root}
            type="warning"
            message={
                <>
                    <p className="mb-0">{__('Wire Transfer Disclosure')}</p>
                    <ol className={styles.list}>
                        <li>{__('A $50.00 wire fee will be deducted from your Withdrawal Amount.')}</li>
                        <li>
                            {__(
                                'TradeUP does not guarantee the wire transfer will be received by receiving bank for same-day credit.'
                            )}
                        </li>
                        <li>
                            {__(
                                'For international wire transfers, please allow up to three to five business days for processing. Additional information may be required to complete a Wire Transfer.'
                            )}
                        </li>
                        <li
                            dangerouslySetInnerHTML={{
                                __html: printf(
                                    __(
                                        'By clicking "Continue", you confirm that you have read and understood our Terms and Conditions and all related disclosures, including our <a href="%s">Transfer Terms and Conditions</a>.'
                                    ),
                                    'https://www.tradeup.com/agreement/USA-Marsco-Transfer-TC'
                                )
                            }}></li>
                    </ol>
                </>
            }
        />
    );
};

export default Instructions;
